import AnvilVideoModal from '@anvilco-pkg/ui/components/video/VideoModal'

import withJsonLd from 'lib/json-ld/withJsonLd'

export default withJsonLd(AnvilVideoModal, {
  jsonLdSchemaName: 'VideoObject',
  getCreateArgs: ({ title, description, videoId }) => ({
    title,
    description,
    videoId,
  }),
})
